class ArchiveCase {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    this.articleImageSwiper();
    this.modalSwiper();
  }

  modalSwiper() {
    const swiperEle = '.js-case-modal-swiper';
    let modalSwiper = new Swiper(swiperEle, {
      loop: false,
      autoHeight: true,
      allowTouchMove: false,
      navigation: {
        nextEl: '.js-case-modal-swiper__next',
        prevEl: '.js-case-modal-swiper__prev',
      },
    })

    const slideMoveEle = document.querySelectorAll('.js-case-modal-to');
    slideMoveEle.forEach((item, key) => {
      item.addEventListener('click', () => {
        modalSwiper.slideTo(key, 0);
      })
    })
  }

  articleImageSwiper() {
    const swiperElements = document.querySelectorAll('.js-case-detail-image-swiper');
    swiperElements.forEach((item, index) => {
      // 各スワイパーにユニークなページネーションクラスを付与
      const paginationClass = `swiper-pagination-${index}`;
      const paginationElement = item.nextElementSibling;
      paginationElement.classList.add(paginationClass);

      const prevClass = `swiper-prev-${index}`;
      const nextClass = `swiper-next-${index}`;
      item.querySelector('.js-case-detail-image-swiper__prev').classList.add(prevClass);
      item.querySelector('.js-case-detail-image-swiper__next').classList.add(nextClass);

      new Swiper(item, {
        allowTouchMove: false,
        navigation: {
          prevEl: `.${prevClass}`,
          nextEl: `.${nextClass}`
        },
        pagination: {
          el: `.${paginationClass}`,  // ユニークなページネーションクラスを参照
          clickable: true,
          renderBullet: function (index, className) {
            const slides = this.slides;
            const slide = slides[index];
            const slideImage = slide.querySelector('img').src;  // スライドの画像URLを取得
            return `<div class="${className}"><img src="${slideImage}" ></div>`;
          },
        },
      });
    });
  }


}


class PageDrone {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
    if ($('.js-page-drone-swiper').length > 0) {
      this.droneSwiper();
    }
  }

  event() {

  }

  droneSwiper() {
    const swiperEle = '.js-page-drone-swiper';
    new Swiper(swiperEle, {
      loop: true,
      speed: 3000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 4000
      }
    })
  }

}


class PageTop {
  constructor(el, opt) {
    this.el = el;
    this.swipersInitialized = {}; // Swiper初期化のフラグ
    this.mvTextSwiper = null;
    this.currentVideoIndex = 0;
    if ($(this.el).length > 0) {
      this.event();
    }
    this.mvTextEle = '.js-mv';
    if ($(this.mvTextEle).length > 0) {
      this.mvTextSlice();
      this.mvTextSwiperInit();
      this.videoSyncSwiper();
    }
    if ($('.js-case-modal-swiper').length > 0) {
      this.modalSwiper();
    }
    if ($('.js-case-detail-image-swiper').length > 0) {
      this.articleImageSwiper();
    }
  }

  event() {
    // 画像切り替えトリガーのホバーイベント
    $('.js-img-change-trigger').hover(function () {
      let index = $(this).index();
      $('.js-img-change').removeClass('is-active');
      $('.js-img-change').eq(index).addClass('is-active');
    });

    // タブのクリックイベント
    document.querySelectorAll('.tab').forEach((tab, index) => {
      tab.addEventListener('click', (event) => this.showTabContent(event, `tab${index + 1}`));
    });

    // 最初のタブとSwiperを初期化
    this.showTabContent(null, 'tab1');
    $('.tab').eq(0).addClass('active');


    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(".animate-element",
      {
        opacity: 0,
        y: 50
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: "ease.in",
        stagger: 0.2, // 子要素をずらして表示
        scrollTrigger: {
          trigger: ".downtoup", // トリガーとなる要素
          start: "top 50%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none",
          markers: false
        },
        onComplete() {
          $('.animate-element').css({ 'opacity': '1', 'transform': 'translate(0)' });
        }
      }
    );

    gsap.fromTo(".bottom-up:not(.swiper-slide-duplicate)",
      {
        opacity: 0,
        y: 20
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "ease.in",
        stagger: 0.3, // 子要素をずらして表示
        scrollTrigger: {
          trigger: ".bottom-up", // トリガーとなる要素
          start: "top center", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none",
          markers: false
        },
        onComplete() {
          $('.bottom-up').css({ 'opacity': '1', 'transform': 'translate(0)' });
        }
      }
    );

    gsap.fromTo(".animate-image",
      {
        opacity: 0,
        x: -300,
        y: -300
      },
      {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 3,
        ease: "power2.out",
        stagger: 0.2, // 子要素をずらして表示
        scrollTrigger: {
          trigger: ".line-animation", // トリガーとなる要素
          start: "top 70%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none", // アニメーションのトリガー設定
          markers: false // デバッグ用のマーカーを表示
        }
      }
    );

    gsap.fromTo(".animate-image-last",
      {
        opacity: 0,
        x: 0,
        y: 10
      },
      {
        opacity: 1,
        y: 0,
        duration: 12,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".line-animation", // トリガーとなる要素
          start: "top 30%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none", // アニメーションのトリガー設定
          markers: false // デバッグ用のマーカーを表示
        }
      }
    );

    gsap.fromTo(".animate-image-sp:not(.animate-image-last-sp)",
      {
        opacity: 0,
        x: -100,
        y: -250
      },
      {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 3,
        ease: "power2.out",
        stagger: 0.2, // 子要素をずらして表示
        scrollTrigger: {
          trigger: ".line-animation-sp", // トリガーとなる要素
          start: "top 70%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none", // アニメーションのトリガー設定
          markers: false // デバッグ用のマーカーを表示
        }
      }
    );

    // 最後の要素のアニメーション
    gsap.fromTo(".animate-image-last-sp",
      {
        opacity: 0,
        x: 0,
        y: 20
      },
      {
        opacity: 1,
        y: 0,
        duration: 12,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".line-animation-sp", // トリガーとなる要素
          start: "top 70%", // スクロール位置の設定
          end: "bottom 20%",
          toggleActions: "play none none none", // アニメーションのトリガー設定
          markers: false // デバッグ用のマーカーを表示
        }
      }
    );
  }

  initializeSwiper(container, scrollbarSelector, scrollbarGrowbarSelector, nextButton, prevButton, slidesPerView, breakpoints) {
    if (this.swipersInitialized[container]) return; // 初期化済みならリターン

    const scrollbar = document.querySelector(scrollbarSelector);
    const scrollbarGrowbar = document.querySelector(scrollbarGrowbarSelector);
    let scrollbarW, scrollbarDragW, progressRange;

    if (scrollbar) {
      new Swiper(container, {
        slidesPerView: slidesPerView,
        allowTouchMove: false,
        spaceBetween: 20,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 500,
        loop: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: scrollbarSelector,
          type: 'progressbar',
        },
        breakpoints: breakpoints,
        on: {
          init: (swiper) => {
            const totalSlidesLen = swiper.slides.length;
          },
          touchStart: (swiper, e) => {
            this.swiperTouchStartX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
          },
          touchEnd: (swiper, e) => {
            const tolerance = 150;
            const totalSlidesLen = swiper.slides.length;
            const diff = e.type === 'touchend' ? e.changedTouches[0].clientX - this.swiperTouchStartX : e.clientX - this.swiperTouchStartX;

            if (swiper.isBeginning && diff >= tolerance) {
              swiper.slideTo(totalSlidesLen - 1);
            } else if (swiper.isEnd && diff <= -tolerance) {
              setTimeout(() => {
                swiper.slideTo(0);
              }, 1);
            }
          },
        },
      });
      ;
      this.swipersInitialized[container] = true; // 初期化済みとしてフラグを立てる
    }
  }

  showTabContent(event, tabId) {
    if (event) {
      event.preventDefault(); // デフォルトのリンク動作を防ぐ
    }

    // すべてのタブとコンテンツを非アクティブ化
    var tabs = document.getElementsByClassName('tab');
    var contents = document.getElementsByClassName('tab-content');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.remove('active');
    }
    for (var i = 0; i < contents.length; i++) {
      contents[i].classList.remove('active-content');
    }

    // クリックされたタブと対応するコンテンツをアクティブ化
    const currentTab = event ? event.currentTarget : document.querySelector(`.tab[data-tab="${tabId}"]`);
    if (currentTab) {
      currentTab.classList.add('active');
    }

    const activeContent = document.getElementById(tabId);
    if (activeContent) {
      activeContent.classList.add('active-content');
    }

    // Swiperの初期化
    if (tabId === 'tab1') {
      this.initializeSwiper('.interview-swiper', "#js-slider__scrollInterview", "#js-slider__scrollGrowbarInterview", '.swiper-button--next', '.swiper-button--prev', 1.5, { 768: { slidesPerView: 'auto' } });
      const slides = document.querySelectorAll('.works-swiper .swiper-slide').length;
      const loopNum = document.querySelector('.works-swiper').dataset.loop ? document.querySelector('.works-swiper').dataset.loop : false;
      let loopSetting;
      if (loopNum) {
        loopSetting = slides > loopNum ? true : false;
      } else {
        loopSetting = true;
      }
      this.initializeSwiper('.works-swiper', "#js-slider__scrollWorks", "#js-slider__scrollGrowbarWorks", '.swiper-button-works--next', '.swiper-button-works--prev', 1.2, { 768: { slidesPerView: 3.5, loop: loopSetting } });
      this.modalSwiper();
      this.articleImageSwiper();
    } else if (tabId === 'tab2') {
      const slides = document.querySelectorAll('.sun-swiper .swiper-slide').length;
      const loopNum = document.querySelector('.sun-swiper').dataset.loop ? document.querySelector('.sun-swiper').dataset.loop : false;
      let loopSetting;
      if (loopNum) {
        loopSetting = slides > loopNum ? true : false;
      } else {
        loopSetting = true;
      }
      this.initializeSwiper('.sun-swiper', "#js-slider__scrollSun", "#js-slider__scrollGrowbarSun", '.swiper-button-sun--next', '.swiper-button-sun--prev', 1.2, { 768: { slidesPerView: 3.5, loop: loopSetting } });
      this.modalSwiper();
      this.articleImageSwiper();
    } else if (tabId === 'tab3') {
      const slides = document.querySelectorAll('.drone-swiper .swiper-slide').length;
      const loopNum = document.querySelector('.drone-swiper').dataset.loop ? document.querySelector('.drone-swiper').dataset.loop : false;
      let loopSetting;
      if (loopNum) {
        loopSetting = slides > loopNum ? true : false;
      } else {
        loopSetting = true;
      }
      this.initializeSwiper('.drone-swiper', "#js-slider__scrollDrone", "#js-slider__scrollGrowbarDrone", '.swiper-button-drone--next', '.swiper-button-drone--prev', 1.2, { 768: { slidesPerView: 3.5, loop: loopSetting } });
      this.modalSwiper();
      this.articleImageSwiper();
    }
  }

  mvTextSwiperInit() {
    const textSwiperElemt = '.js-mv-text-swiper';
    this.mvTextSwiper = new Swiper(textSwiperElemt, {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      on: {
        slideChangeTransitionStart: () => {
          gsap.to('.js-mv-text-swiper .swiper-slide', {
            opacity: 0
          })
        },
        slideChange: () => {
          setTimeout(() => this.mvTextAnime(), 50);
        },
        resize: () => {
          this.updateSlideVisibility();
        }
      }
    })

  }

  videoSyncSwiper() {

    var videos = document.querySelectorAll('.js-mv-video video');
    this.currentVideoIndex = 0;

    // 最初のビデオを再生
    videos[this.currentVideoIndex].play();

    // ビデオ終了時に次のビデオを再生
    const playNextVideo = () => {
      // 現在のビデオを停止して非表示
      videos[this.currentVideoIndex].style.display = 'none';
      videos[this.currentVideoIndex].pause();
      videos[this.currentVideoIndex].currentTime = 0;

      // 次のビデオのインデックスを計算して再生
      this.currentVideoIndex = (this.currentVideoIndex + 1) % videos.length;
      videos[this.currentVideoIndex].style.display = 'block';
      videos[this.currentVideoIndex].play();

      this.mvTextSwiper.slideNext();

    }

    // すべてのビデオに 'ended' イベントリスナーを追加
    videos.forEach(function (video) {
      video.addEventListener('ended', playNextVideo);
    });
  }


  updateSlideVisibility() {
    // アクティブなスライドの取得
    const activeSlide = document.querySelector('.swiper-slide-active');

    // 全スライドの取得
    const allSlides = document.querySelectorAll('.js-mv-text-swiper .swiper-slide');

    // 全てのスライドを非表示にし、アクティブなスライドのみ表示
    allSlides.forEach(slide => {
      if (slide === activeSlide) {
        // アクティブなスライドは表示する
        gsap.to(slide, {
          opacity: 1,
          duration: 0
        });
      } else {
        // 非アクティブなスライドは非表示にする
        gsap.to(slide, {
          opacity: 0,
          duration: 0
        });
      }
    });
  }

  mvTextSlice() {
    let $container = $('.js-mv-text');

    let number = 0;
    $container.each(function () {
      number++;
      $(this).addClass('is-' + number);
      let html = $(this).html();
      let wrappedText = '';
      let isTag = false;

      for (let i = 0; i < html.length; i++) {
        if (html[i] === '<') {
          // タグの開始を検出
          let tagStart = i;
          while (html[i] !== '>' && i < html.length) {
            i++;
          }
          let tag = html.substring(tagStart, i + 1);

          // <br>タグ（クラス付きや属性付きも含む）を検出
          if (/^<br\s*\/?>/i.test(tag)) {
            wrappedText += tag; // <br>タグ全体をそのまま追加
          } else {
            wrappedText += tag; // 他のタグの場合もそのまま追加
          }
        } else {
          // テキストを1文字ずつ<span>で囲む
          wrappedText += '<span style="display: inline-block;">' + html[i] + '</span>';
        }
      }
      $(this).html(wrappedText);
    });
  }


  mvTextAnime() {

    let tl = gsap.timeline();

    tl
      .to('.js-mv-text-swiper .swiper-slide-active', {
        opacity: 1
      })
      .fromTo('.js-mv-text-swiper .swiper-slide-active .js-mv-en', {
        opacity: 0,
        y: 20,
      }, {
        opacity: 1,
        y: 0,
      }, '+=0.5')
      .to(".js-mv-text", 1, {
        opacity: 1,
      },)
      .fromTo(".js-mv-text-swiper .swiper-slide-active .js-mv-text span", {
        opacity: 0,
        y: 30,
        duration: 1500,
      }, {
        opacity: 1,
        y: 0,
        stagger: 0.1 // スタグアニメーションの間隔
      }, '<=')
      .fromTo(".js-mv-text-swiper .swiper-slide-active .js-mv-txt", {
        opacity: 0,
        y: 20,
      }, {
        opacity: 1,
        y: 0,
      })
  }

  modalSwiper() {
    const swiperElements = document.querySelectorAll('.js-case-modal-swiper');

    swiperElements.forEach((swiperEle, index) => {

      const parentSwiper = swiperEle.closest('.js-modal');
      const siblingElement = swiperEle.nextElementSibling;

      // 各スワイパーにユニークなナビゲーションクラスを付与
      const nextClass = `swiper-next-${index}`;
      const prevClass = `swiper-prev-${index}`;

      const nextEle = parentSwiper.querySelectorAll('.js-case-modal-swiper__next');
      nextEle.forEach((item) => {
        item.classList.add(nextClass);
      })
      const prevEle = parentSwiper.querySelectorAll('.js-case-modal-swiper__prev');
      prevEle.forEach((item) => {
        item.classList.add(prevClass);
      })

      // 各スワイパーのインスタンスを初期化
      const modalSwiper = new Swiper(swiperEle, {
        loop: false,
        allowTouchMove: false,
        navigation: {
          nextEl: `.${nextClass}`,  // ユニークな次ボタンクラスを参照
          prevEl: `.${prevClass}`,  // ユニークな前ボタンクラスを参照
        },
        init: index === 0
      });

      // スライド移動用の要素を取得し、クリックでスライドを移動
      const slideMoveEle = parentSwiper.querySelectorAll('.js-case-modal-to');
      slideMoveEle.forEach((item, key) => {
        item.addEventListener('click', () => {
          if (!modalSwiper.initialized) {
            modalSwiper.init();  // Swiperを初期化
          }
          const modalTo = item.dataset.key;
          modalSwiper.slideTo(modalTo, 0);  // 対応するスライドに移動
        });
      });
    });
  }


  articleImageSwiper() {
    const swiperElements = document.querySelectorAll('.js-case-detail-image-swiper');
    swiperElements.forEach((item, index) => {
      // 各スワイパーにユニークなページネーションクラスを付与
      const paginationClass = `swiper-pagination-${index}`;
      const paginationElement = item.nextElementSibling;
      paginationElement.classList.add(paginationClass);

      const prevClass = `swiper-prev-${index}`;
      const nextClass = `swiper-next-${index}`;
      item.querySelector('.js-case-detail-image-swiper__prev').classList.add(prevClass);
      item.querySelector('.js-case-detail-image-swiper__next').classList.add(nextClass);

      new Swiper(item, {
        allowTouchMove: false,
        navigation: {
          prevEl: `.${prevClass}`,
          nextEl: `.${nextClass}`
        },
        pagination: {
          el: `.${paginationClass}`,  // ユニークなページネーションクラスを参照
          clickable: true,
          renderBullet: function (index, className) {
            const slides = this.slides;
            const slide = slides[index];
            const slideImage = slide.querySelector('img').src;  // スライドの画像URLを取得
            return `<div class="${className}"><img src="${slideImage}" ></div>`;
          },
        },
      });
    });
    const modalToglle = document.querySelectorAll('.js-swiper-init');
    modalToglle.forEach((item) => {
      item.addEventListener('click', () => {
        this.articleImageSwiper();
      })
    })
  }

}
class SingleProducts {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const productsSwiperElements = '.js-product-image-swiper';
    if (document.querySelectorAll(productsSwiperElements).length > 0) {
      this.productsSwiper(productsSwiperElements);
    }
    const catSwiperElements = '.js-products-cat-swiper';
    if (document.querySelectorAll(catSwiperElements).length > 0) {
      this.catSwiper(catSwiperElements);
    }
  }

  productsSwiper(productsSwiperElements) {
    const swiperElements = document.querySelectorAll(productsSwiperElements);
    swiperElements.forEach((item, index) => {
      // 各スワイパーにユニークなページネーションクラスを付与
      const paginationClass = `swiper-pagination-${index}`;
      const paginationElement = item.nextElementSibling;
      paginationElement.classList.add(paginationClass);

      const prevClass = `swiper-prev-${index}`;
      const nextClass = `swiper-next-${index}`;
      item.querySelector('.js-case-detail-image-swiper__prev').classList.add(prevClass);
      item.querySelector('.js-case-detail-image-swiper__next').classList.add(nextClass);

      new Swiper(item, {
        allowTouchMove: false,
        navigation: {
          prevEl: `.${prevClass}`,
          nextEl: `.${nextClass}`
        },
        pagination: {
          el: `.${paginationClass}`,  // ユニークなページネーションクラスを参照
          clickable: true,
          renderBullet: function (index, className) {
            const slides = this.slides;
            const slide = slides[index];
            const slideImage = slide.querySelector('img').src;  // スライドの画像URLを取得
            return `<div class="${className}"><img src="${slideImage}" ></div>`;
          },
        },
      });
    });
  }

  catSwiper(catSwiperElements) {
    new Swiper(catSwiperElements, {
      slidesPerView: 1.8,
      spaceBetween: 20,
      navigation: {
        nextEl: catSwiperElements + '__next',
        prevEl: catSwiperElements + '__prev',
      },
      pagination: {
        el: catSwiperElements + '__progress',
        type: 'progressbar',
      },
      breakpoints: {
        769: {
          slidesPerView: 'auto',
          spaceBetween: 0
        }
      }
    })
  }


}


class Accordion {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {

    // 初期画像を設定
    $(".main-image").attr("src", $(".accordion-title").first().data("image"));

    // アコーディオンタイトルがクリックされた時の処理
    $(".accordion-title").click(function () {
      // 現在クリックされたタイトルの次の要素（コンテンツ）
      var content = $(this).next(".accordion-content");
      var newImage = $(this).data("image"); // クリックされたタイトルに対応する画像を取得

      // すでに開いている他のコンテンツを閉じて、is-activeクラスを削除
      $(".accordion-content").not(content).slideUp();
      $(".accordion-title").not($(this)).removeClass("is-active");

      // クリックされたタイトルに対応するコンテンツをトグル（開閉）し、is-activeクラスをトグル
      content.slideToggle();
      $(this).toggleClass("is-active");

      // 画像を切り替え
      if ($(this).hasClass("is-active")) {
        $(".main-image").attr("src", newImage);
      }
    });
  }
}





class AutoContinuousSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const swiperElements = document.querySelectorAll("." + this.el);
    swiperElements.forEach((swiper) => {
      const swiperSpeed = swiper.dataset.speed ? swiper.dataset.speed : 3000;
      new Swiper(swiper, {
        loop: true,
        speed: 10000,
        slidesPerView: 'auto',
        autoplay: {
          delay: 0,
        }
      })
    })
  }
}
class Breadcrumb {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }

  event() {
    const mm = gsap.matchMedia();

    mm.add('(max-width: 768px)', () => {
      const breadEle = document.querySelector('.' + this.el + ' > nav');

      if (breadEle) {
        // 子要素を取得
        const children = breadEle.children;
        let totalWidth = 0;
        const gap = 9.6; // 0.6remはデフォルトで9.6px (1rem = 16pxと仮定)

        // 子要素の横幅を合計
        Array.from(children).forEach(child => {
          totalWidth += child.offsetWidth;  // 各子要素の横幅を加算
        });

        // gapの合計 (子要素がn個の場合、隙間はn-1個)
        const gapTotal = (children.length - 1) * gap;

        // 合計にgapの幅を加える
        totalWidth += gapTotal;

        breadEle.style.width = totalWidth + 'px';
        console.log('Total width of children including gaps:', totalWidth);
      }
    });
  }
}
class ContactAccept {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const dataAccept = document.querySelector('[data-accept]').dataset.accept;
    const acceptEle = document.querySelector('.js-acceptance');
    acceptEle.querySelector('a').href = dataAccept;
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get: function (cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData = document.cookie,
			getCookieAllDatas = getCookieAllData.split(';'),
			getCookieDatas = {},
			cookieKeyValue = [],
			cookieKey = '',
			cookieValue = '';

		var hashLength = function (arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set: function (cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
			dt = new Date();
			ts = dt.getTime();

			// 1時間後
			ts_after = ts + (1000 * 60 * 60 * expires);

			date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del: function (cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
				date = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class FormErrorTxtControl {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    $('.wpcf7-form-control').closest('.c-more-btn').click(function() {
      $('.wpcf7-not-valid-tip').css({'display': 'block'});
      let timeOut = setInterval(() => {
        if($('.wpcf7-not-valid-tip').length) {
          $('.wpcf7-not-valid-tip').css({'display': 'block'});
          clearInterval(timeOut);
        }
      }, 100);
    })
  }
}
class Header {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    $('.js-drawer-trigger').click(function () {
      $(this).toggleClass('is-active');
      $('.js-drawer-inner').toggleClass('is-active');
      $('.js-header, .js-header *').toggleClass('is-h-color');
      scrollBan();
    })

    // ヘッダー内のアンカーリンククリック時の対応
    $('.js-header-smooth-link').on('click', function (event) {
      var target = $(this.getAttribute('href'));

      if (target.length) {
        event.preventDefault();
        $('.js-drawer-trigger').removeClass('is-active');
        $('.js-drawer-inner').removeClass('is-active');
        $('.js-header, .js-header *').removeClass('is-h-color');
        scrollBan();
        setTimeout(() => {
          $('html, body').stop().animate({
            scrollTop: target.offset().top // スクロール位置を調整
          }, 500);
        }, 300)
      }
    });

    if ($('.js-header').hasClass('top')) {

      gsap.to('.js-h-show', { // .box => アニメーションさせる要素
        scrollTrigger: {
          trigger: "body",
          start: "+=600",
          onEnter: () => {
            $('html').addClass('is-h-show');
            $('.js-header, .js-header *').addClass('is-h-show');
          },
          onLeaveBack: () => {
            $('html').removeClass('is-h-show');
            $('.js-header, .js-header *').removeClass('is-h-show');
          },
        }
      });
    } else {
      $('html').addClass('is-h-show');
      $('.js-header, .js-header *').addClass('is-h-show');
    }

    gsap.to('.js-header', { // .box => アニメーションさせる要素
      scrollTrigger: {
        trigger: "js-header",
        start: "top top",
        end: "top+=100 top",
        onEnter: () => {
          $('html').addClass('is-h-hidden');
          $('.js-header, .js-header *').addClass('is-h-hidden');
        },
        onLeaveBack: () => {
          $('html').removeClass('is-h-hidden');
          $('.js-header, .js-header *').removeClass('is-h-hidden');
        },
      }
    });

    // クエリを定義
    const mediaQuery = window.matchMedia('(max-width: 767px)')

    if (mediaQuery.matches) {
      $(".js-header-accordion").click(function (e) {
        e.preventDefault();
        const dataAttr = $(this).attr('data-attr');
        if (dataAttr) {
          location.href = dataAttr;
        } else {
          $(this).next().slideToggle();
          $(this).toggleClass('is-active');
        }
      })
      $(".js-header-accordion .plus").click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().next().slideToggle();
        $(this).parent().toggleClass('is-active');
      })
    }
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index) => {
      let property, scrub;

      $(ele).css({
        'object-fit': 'cover',
        'object-position': '50% 0%',
        'width': '100%',
        'height': '100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt) {
    $('.js-load-inview').animate({ 'opacity': '1' });
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if ($(this.el).length > 0) {
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if (entry.intersectionRatio >= 0.05) {
          item.classList.add('is-inview');
          if (item.classList.contains('js-inview-each')) {
            this.inviewEachUp(item);
          }
          if (item.classList.contains('js-inview-lottie')) {
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if (entry.intersectionRatio >= 0.9) {
          item.classList.add('is-inview');
          if (item.classList.contains('js-inview-each')) {
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e) => {
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e) => {
      observerAll.observe(e);
    });
  }
  inviewEachUp(item) {
    $(item).find(this.eachItem).each((i, el) => {
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: () => {
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i, el) => {
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: () => {
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i, el) => {
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: () => {
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item) {
    if ($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if ($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if ($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if ($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if ($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if ($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if ($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if ($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

// IntersectionObserver のインスタンスを作成
let observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { // 要素がビューポート内に入ったとき
      let element = entry.target;
      element.src = element.dataset.src; // data-src から実際の src を設定
      observer.unobserve(element); // 一度読み込んだら監視を終了する
    }
  });
}, {
  rootMargin: '200px' // ビューポートから200px手前で読み込み開始
});

// 監視したいimgとiframeを選択
let lazyElements = document.querySelectorAll('img[data-src], iframe[data-src]');

// すべてのimgとiframeを監視
lazyElements.forEach(element => {
  if (!element.closest('[x-data]')) {
    observer.observe(element); // 表示されている要素だけを監視
  }
});

// x-data を持つ要素内の img と iframe の遅延読み込み用の IntersectionObserver を作成
let observerForXData = new IntersectionObserver((entries, observerForXData) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { // x-data を持つ要素がビューポート内に入ったとき
      let parentElement = entry.target;
      let lazyElementsInXData = parentElement.querySelectorAll('img[data-src], iframe[data-src]'); // 子要素の img と iframe を取得

      // 親要素がビューポート内に入ったら、その中の img と iframe を読み込み
      lazyElementsInXData.forEach(element => {
        element.src = element.dataset.src; // data-src から実際の src を設定
      });

      observerForXData.unobserve(parentElement); // 一度監視を終了する
    }
  });
}, {
  rootMargin: '200px' // ビューポートから200px手前で読み込み開始
});

// 監視したい x-data を持つ要素を選択
let parentElementsWithXData = document.querySelectorAll('[x-data]');

// x-data を持つ要素を監視
parentElementsWithXData.forEach(parentElement => {
  observerForXData.observe(parentElement); // x-data を持つ要素を監視対象として登録
});

class LeftAnkerNav {
  constructor(el, opt) {
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().siblings().removeClass('is-active')
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().addClass('is-active')
        } else {
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    $(".js-nav-target a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })
  }
}
class NumCountUp {
  constructor(el) {
    this.el = el;
    // 要素を取得して監視を開始する
    const items = document.querySelectorAll("." + this.el);
    this.initObserver(items);
  }

  initObserver(items) {
    const options = {
      threshold: 1  // カウンター要素がすべて画面に表示されたとき(= 1)
    };

    const observer = new IntersectionObserver((entries) => {
      this.shuffleNumberCounter(entries);
    }, options);

    items.forEach(target => {
      observer.observe(target);
    });
  }

  shuffleNumberCounter(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('is-visible')) {
        const counterEle = entry.target;
        const from = parseFloat(entry.target.dataset.from || 0);
        const to = parseFloat(entry.target.dataset.to || 0);
        const duration = parseInt(entry.target.dataset.duration) || 1500;

        if (!Number.isFinite(from) || !Number.isFinite(to) || from > to) {
          return false;
        }

        const increment = to - from;
        const decimalPointLength = getDecimalPointLength(increment);
        const startTime = performance.now();

        const countUp = (timestamp) => {
          const elapsed = performance.now() - startTime;
          const countValue = (from + ((elapsed / duration) * increment)).toFixed(decimalPointLength);

          if (countValue >= to) {
            counterEle.innerText = to;
          } else {
            counterEle.innerText = parseFloat(countValue);
            requestAnimationFrame(countUp);
          }
        };

        requestAnimationFrame(countUp);
        entry.target.classList.add('is-visible');
      }
    });
  }

  event() {
    console.log('イベント');
  }
}

function getDecimalPointLength(number) {
  const str = number.toString();
  const index = str.indexOf('.');
  return index === -1 ? 0 : str.length - index - 1;
}

class PostImageRetina {
  constructor(el) {
    this.el = el;
    if ($(this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const elementWrap = document.querySelector(this.el);
    const images = elementWrap.querySelectorAll('.wp-block-image');
    images.forEach((item) => {
      if (item.classList.contains('is-retina')) {
        const retinaImage = item.querySelector('img');
        if (retinaImage.hasAttribute('width')) {
          const itemWidth = parseInt(retinaImage.getAttribute('width'), 10); // width属性を数値として取得
          const styleWidth = (itemWidth / 2) + 'px'; // 幅を半分にし、rem単位を追加
          retinaImage.style.width = styleWidth;
        }
      }
    });
  }

}

// ProductsSwiper class
class ProductsSwiper {
  constructor(el) {
    this.el = el.startsWith('.') ? el.slice(1) : el; // Remove the leading dot to use as a class name
    if ($("." + this.el).length > 0) {
      this.initSwipers();
    }
  }

  initSwipers() {
    const swiperEle = "." + this.el;

    // Initialize the thumbnail Swiper
    const mySwiper_thumb = new Swiper(swiperEle + ' .swiper-sub', {
      slidesPerView: 'auto',
      spaceBetween: 10,
      freeMode: true,
      watchSlidesProgress: true,
    });

    // Initialize the main Swiper
    const mySwiper_main = new Swiper(swiperEle + ' .swiper-main', {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 500,
      loop: true,
      autoplay: {
        delay: 2000,
      },
      thumbs: {
        swiper: mySwiper_thumb, // Link the thumbnail Swiper
      },
    });
  }
}

// Instantiate the ProductsSwiper class
new ProductsSwiper('.products-swiper');

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    setTimeout(function () {
      window.scrollTo(0, scrollTop);
    }, 10);
    setTimeout(function () {
      body.classList.add('scroll-smooth');
    }, 10);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
    body.classList.remove('scroll-smooth');
  }
}
// スムーススクロール
(function () {
  $('a[href^="#"]').on('click', function (event) {
    var target = $(this.getAttribute('href'));

    if (target.length) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top // スクロール位置を調整
      }, 500);
    }
  });
}());
class TextSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const swiperEle = "." + this.el;
    new Swiper(swiperEle, {
      loop: true,
      speed: 10000,
      slidesPerView: 'auto',
      autoplay: {
        delay: 0,
      }
    })
  }
}
class VoiceModalSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    this.articleImageSwiper();
    this.modalSwiper();
  }

  modalSwiper() {
    const swiperEle = '.js-voice-modal-swiper';
    let modalSwiper = new Swiper(swiperEle, {
      loop: false,
      autoHeight: true,
      allowTouchMove: false,
      navigation: {
        nextEl: '.js-voice-modal-swiper__next',
        prevEl: '.js-voice-modal-swiper__prev',
      },
    })

    const slideMoveEle = document.querySelectorAll('.js-voice-modal-to');
    slideMoveEle.forEach((item, key) => {
      item.addEventListener('click', () => {
        modalSwiper.slideTo(key, 0);
      })
    })
  }

  articleImageSwiper() {
    const swiperElements = document.querySelectorAll('.js-voice-detail-image-swiper');
    swiperElements.forEach((item, index) => {
      // 各スワイパーにユニークなページネーションクラスを付与
      const paginationClass = `swiper-pagination-${index}`;
      const paginationElement = item.querySelector('.js-voice-detail-image-swiper__pagination');
      paginationElement.classList.add(paginationClass);

      new Swiper(item, {
        allowTouchMove: true,
        pagination: {
          el: `.${paginationClass}`,  // ユニークなページネーションクラスを参照
          clickable: true,
          type: 'bullets'
        },
      });
    });
  }


}


class YoutubeEmbedControl {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector('.js-youtube-stop')) {
      this.stop();
    }
  }

  event() {
  }
  
  iframeController(target, action, arg = '[]') {
    target.contentWindow.postMessage('{"event":"command", "func":"' + action + '", "args":' + arg + '}', '*');
}

  stop() {
    const stopBtns = document.querySelectorAll('.js-youtube-stop');

    stopBtns.forEach((btn)=>{
      btn.addEventListener('click',()=>{
        const youtubeEmbeds = document.querySelectorAll('.wp-block-embed.is-provider-youtube iframe');
        youtubeEmbeds.forEach((embed)=>{
          this.iframeController(embed,'stopVideo');
        })
      })
    })
  }

}

(() => {

})();

//DOMContentLoaded
$(() => {
  new ContactAccept('js-acceptance');
  new ArchiveCase('js-archive-case');
  new SingleProducts('js-single-pdoructs');
  new TextSwiper('js-text-swiper');
  new PostImageRetina('.js-post-image-retina');
  new VoiceModalSwiper('js-voice-modal-swiper');
  new PageDrone('js-page-drone');
  new AutoContinuousSwiper('js-auto-continuous-swiper');
  new Breadcrumb('js-breadcrumb');
  new YoutubeEmbedControl();
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {

  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let header = new Header('js-header');
  let accordion = new Accordion('js-accordion');
  let pageTop = new PageTop('.p-top');
  let leftAnkerNav = new LeftAnkerNav('js-nav-target');

});